import { API } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export async function validateMissionTrackingsSalaries(ids: number[]) {
  return restApiClient.url(API.missionTrackings.validateMissionTrackingsSalaries.url).post({ ids })
}
